module.exports = __webpack_public_path__ + "img/gsgc2903_1.8f4c4518.svg";